module.exports = __webpack_public_path__ + "img/caret.78066db6.svg";